import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import CityPageTemplate from '../../components/templates/CityPageTemplate';
import { getCity } from '../../data/cities';
import { ROUTES } from '../../enum/routes';

export default function LocationPage() {
  const { citySlug } = useParams<{ citySlug: string }>();
  const city = citySlug ? getCity(citySlug) : undefined;
  if (!city) return <Navigate to={ROUTES.SERVICE_AREAS} replace />;
  return <CityPageTemplate city={city} />;
}
